import {
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  UntypedFormControl,
  Validators,
} from '@angular/forms';

/**
 * Conditionally check to see if at least one field has been populated.
 * Good for when at least one field (either / or) needs to be required.
 * Example: 'email' and 'phone' may have its own validation requirements,
 * however, only one of those need to be populated to be a valid form.
 * @param controlNames
 * @returns
 */
export function RequiresOne(...controlNames: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) {
      // FormGroup Validation
      for (const controlName of controlNames) {
        const testControl = control.get(controlName) as UntypedFormControl;
        if (testControl != null) {
          if (!Validators.required(testControl)) {
            return null;
          }
        }
      }
    } else {
      console.error('RequiresOne: Did you apply the validator on the FormGroup?');
      return null;
    }
    return { requiresOne: true };
  };
}
